/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BannedItemBulkCreateDTO interface.
 */
export function instanceOfBannedItemBulkCreateDTO(value) {
    if (!('values' in value) || value['values'] === undefined)
        return false;
    if (!('marketplaces' in value) || value['marketplaces'] === undefined)
        return false;
    return true;
}
export function BannedItemBulkCreateDTOFromJSON(json) {
    return BannedItemBulkCreateDTOFromJSONTyped(json, false);
}
export function BannedItemBulkCreateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'values': json['values'],
        'marketplaces': json['marketplaces'],
        'categoryPaths': json['categoryPaths'] == null ? undefined : json['categoryPaths'],
    };
}
export function BannedItemBulkCreateDTOToJSON(json) {
    return BannedItemBulkCreateDTOToJSONTyped(json, false);
}
export function BannedItemBulkCreateDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'values': value['values'],
        'marketplaces': value['marketplaces'],
        'categoryPaths': value['categoryPaths'],
    };
}
